import PropTypes from 'prop-types';

export const activityLogChangeType = PropTypes.shape({
  before: PropTypes.string,
  after: PropTypes.string
});
